import DealVehicleEditor from '@/components/deal/vehicle/deal-vehicle-editor';
import { DealPreorderBadge } from '@/components/ui/deal-preorder-badge';
import { PDKVehicleSwapIcon } from '@/components/ui/pdk-icons';
import HoverClickStay from '@/components/ux/hover-click-stay';
import { Deal } from '@/models/registry';
import { observer } from 'mobx-react-lite';
import { Column, Row } from './non-mobile-main';

export const NonMobileVehicleRow = observer(
  ({
    deal,
    setOpenVehicleSwapDialog,
  }: {
    deal: Deal;
    setOpenVehicleSwapDialog: (open: boolean) => void;
  }) => {
    return (
      <Row>
        <Column align="start">
          <div className="flex flex-col gap-1">
            <HoverClickStay
              key="vehicle-swap-hover"
              tether={
                <div
                  onClick={() => {
                    setOpenVehicleSwapDialog(true);
                  }}
                >
                  <PDKVehicleSwapIcon className="h-3.5 w-3.5 cursor-pointer" />
                </div>
              }
            >
              <h5 className="scroll-m-20 text-lg  tracking-tight w-full flex flex-row gap-2 items-center">
                Vehicle
                <DealPreorderBadge
                  is_pre_order={deal.vehicle_listing?.is_pre_order || false}
                />
              </h5>
            </HoverClickStay>

            {deal.vehicle_listing && (
              <DealVehicleEditor
                vehicle={deal.vehicle_listing}
                dealId={deal.id}
                dealShortId={deal.short_id}
                vehicleCurrentLocation={deal.vehicle_current_location}
                protectionPlan={deal.protection_plan || null}
                priceBreakdown={deal.price_breakdown}
                rapidReconStep={deal.rapid_recon_step}
                deliveryStage={deal.delivery_stage}
                vehicleDeliveryOdometer={deal.vehicle_delivery_odometer || 0}
                appraisals={deal.appraisals}
              />
            )}
          </div>
        </Column>

        <Column align="end">
          <></>
        </Column>
      </Row>
    );
  },
);
